var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { attrs: { label: _vm.name, prop: _vm.code, rules: _vm.rules } },
    [
      _c("el-popover", {
        attrs: { placement: "bottom-start", trigger: "focus" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-row align-center mb-10 tag-wrapper",
                  },
                  [
                    _c("span", { staticClass: "font-bold mb-5" }, [
                      _vm._v("已选："),
                    ]),
                    _vm._l(_vm.labels, function (tag) {
                      return _c(
                        "el-tag",
                        {
                          key: tag.id,
                          staticClass: "mb-5",
                          attrs: {
                            "disable-transitions": false,
                            closable: "",
                            size: "small",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleMoveTag(tag)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(tag.name) + " ")]
                      )
                    }),
                  ],
                  2
                ),
                _c("el-input", {
                  staticClass: "mb-10",
                  attrs: {
                    placeholder: "请输入内容,按回车搜索",
                    "prefix-icon": "el-icon-search",
                  },
                  on: { change: _vm.handleEnter },
                  model: {
                    value: _vm.searcher.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.searcher, "name", $$v)
                    },
                    expression: "searcher.name",
                  },
                }),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "multipleTable",
                    staticClass: "mb-10",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      "row-key": "code",
                      "tooltip-effect": "dark",
                    },
                    on: { "selection-change": _vm.handleSelectChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        "reserve-selection": true,
                        type: "selection",
                        width: "55",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "code", prop: "code", width: "120" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "名称", prop: "name", width: "120" },
                    }),
                  ],
                  1
                ),
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pagination.pageNo,
                    "page-size": _vm.pagination.pageSize,
                    total: _vm.pagination.total,
                    background: "",
                    layout: "prev, pager, next ,total",
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.pagination, "pageNo", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.pagination, "pageNo", $event)
                    },
                    "current-change": _vm.pageChange,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "reference",
            fn: function () {
              return [
                _c("el-input", {
                  scopedSlots: _vm._u(
                    [
                      _vm.labels
                        ? {
                            key: "prefix",
                            fn: function () {
                              return [
                                _vm.labels.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-row align-center",
                                        staticStyle: { height: "38px" },
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.labels.length > 0,
                                                expression: "labels.length>0",
                                              },
                                            ],
                                            staticStyle: {
                                              margin: "2px 0 2px 6px",
                                            },
                                            attrs: {
                                              size: "small",
                                              type: "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.labels[0].name) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-tag",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.labels.length > 1,
                                                expression: "labels.length>1",
                                              },
                                            ],
                                            staticStyle: {
                                              margin: "2px 0 2px 6px",
                                            },
                                            attrs: {
                                              size: "small",
                                              type: "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " +" +
                                                _vm._s(_vm.labels.length - 1) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }